import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import Listing from "../../lessons/Listing";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import { fetchHobbyweight } from "../../../redux/action/weightAction";

const Hobbyweights = () => {
  const dispatch = useDispatch();
  const { hobbyweightsList, isLoading } = useSelector(
    (state) => state?.weightReducer
  );

  useEffect(() => {
    dispatch(fetchHobbyweight());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div>
        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Hobbyweights"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Hobbyweights",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <Listing contentData={hobbyweightsList} />

        <Footer />
      </div>
    </>
  );
};

export default Hobbyweights;
